
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
    display:block;
}

.text-card .container {
    margin-left:auto;
    margin-right:auto;
}

.text-card .container {
    max-width:1024px;
}

.text-card--center .container {
    text-align:center;
}

.text-card--center .container ::slotted([slot='links']) {
    justify-content:center;
}

.text-card--right .container {
    text-align:right;
}

.text-card--right .container ::slotted([slot='links']) {
    justify-content:flex-end;
}

.text-card--full-bleed .container {
    max-width:100%;
}

::slotted([slot='eyebrow']) {
    margin-bottom:1rem;
    display:block;
    text-transform:uppercase;
}

::slotted([slot='content']) {
    margin-bottom:2rem;
}

::slotted([slot='links']) {
    display:flex;
    flex-wrap:wrap;
    gap:0.75rem;
}

.outline-shadow {
    --tw-shadow:0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow:0 0 #0000, 0 0 #0000, 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.outline-rounded-2xl {
    border-radius:1rem;
}

:host([site='BH']) .wrapper {
    padding-top:2.5rem;
    padding-bottom:2.5rem;
}

:host([site='BH']):host([is-basic-block]) .wrapper {
    padding:0px;
}

:host([site='BH']) ::slotted([slot='eyebrow']) {
    font-family:var(--bh-ff-body);
}

:host([site='BH']) ::slotted([slot='eyebrow']) {
    font-size:var(--bh-fs-body-01);
    line-height:var(--bh-lh-body-01);
    letter-spacing:var(--bh-ls-body-01);
}

:host([site='BH']) ::slotted([slot='eyebrow']) {
    font-weight:var(--fw-bold);
}

:host([site='BH']) ::slotted([slot='content']) {
    font-family:var(--bh-ff-body);
}

:host([site='BH']) ::slotted([slot='content']) {
    font-size:var(--bh-fs-body-02);
    line-height:var(--bh-lh-body-02);
    letter-spacing:var(--bh-ls-body-02);
}

:host([site='BH']) ::slotted([slot='content']){
    margin-bottom:0 !important;
  }
`;